import TlsProfile from 'routes/TlsProfile/TLSProfile';
import JurisdictionArea from 'routes/JurisdictionArea';
import Filters from 'routes/Filters';
import LogView from 'routes/Log/LogView';
import MediaGateway from 'routes/MediaGateway/MediaGateway';
import Alarm from 'routes/Alarm';
import ActiveAlarmList from 'routes/Alarm/containers/ActiveAlarmList';
import HistoricalAlarmList from 'routes/Alarm/containers/HistoricalAlarmList';
import SuppressedAlarmList from 'routes/Alarm/containers/SuppressedAlarmList';
import AlarmNotificationProfile from 'routes/AlarmNotificationProfile/AlarmNotificationProfile';
import UtimacoCircuitSwitch from 'routes/UtimacoCircuitSwitch/UtimacoCircuitSwitch';
import Xcca from 'routes/xcca/xcca';
import SnmpUser from 'routes/SnmpUser/SnmpUser';
import SnmpDestination from 'routes/SnmpDestination/SnmpDestination';
import Contact from 'routes/Contact';
import EWarrant from 'routes/EWarrant';
import UsersModule from './users';
import TeamsModule from './teams';
import RolesModule from './roles';
import SecurityPolicy from './routes/SecurityPolicy';
import AuditModule from './audit/general-audit';
import UserAuditModule from './audit/user-audit';
import AccessFunction from './routes/AccessFunction';
import CollectionFunction from './routes/CollectionFunction';
import Distributor from './routes/Distributor';
import ProcessOptions from './routes/ProcessOptions';
import IRIBuffering from './routes/IRIBuffering';
import PerodicAudit from './routes/PerodicAudit';
import TlsProxy from './routes/TlsProxy';
import CollectionFunctionGroup from './routes/CollectionFunctionGroup';
import CspConfig from './routes/CspConfig';
import Tenant from './routes/CspConfig/Tenant';
import DialedDigitExtractionServer from './routes/DialedDigitExtractionServer';
import UtimacoPacketSwitch from './routes/UtimacoPacketSwitch';
import TargetDeliveryTemplateAccessFunction from './routes/TargetDeliveryTemplateAccessFunction';
import WarrantsModule from './xcipio/warrants';
import CasesModule from './xcipio/cases';
import WiretapsModule from './xcipio/wiretaps';
import NetworkId from './routes/NetworkId';
import RadiusParserOptions from './routes/RadiusParserOptions';
import Xdp from './routes/Xdp';
import TargetDomain from './routes/TargetDomain';
import NatConfiguration from './routes/NatConfiguration';
import CfFtpInfo from './routes/CfFtpInfo';
import FilterGroup from './routes/FilterGroup';
import AfFilter from './routes/AfFilter';
import SipSetting from './routes/SipSetting';
import RegisteredNodes from './routes/RegisteredNodes';
import BackupRestore from './routes/BackupRestore';
import ExternalApps from './components/external-apps';
import Fqdn from './routes/Fqdn';
import Xtp from './routes/Xtp';
import AfWhitelist from './routes/AfWhitelist';
import XtpXdpConnection from './routes/XtpXdpConnection';
import RadiusParserPassword from './routes/RadiusParserPassword';
import SshSecurityInformation from './routes/SshSecurityInformation'
import NetworkTopology from './routes/NetworkTopology';

import {
  CF_ROUTE,
  AF_ROUTE,
  SYSTEM_CONFIGURATION_ROUTE,
  SECURITY_GATEWAY_ROUTE,
  DISTRIBUTORS_ROUTE,
  DIALED_DIGIT_EXTRACTION_SERVER_ROUTE,
  IRI_BUFFERING_ROUTE,
  PERIODIC_AUDIT_ROUTE,
  UTIMACO_PACKET_SWITCH_ROUTE,
  UTIMACO_CIRCUIT_SWITCH_ROUTE,
  TARGET_DELIVERY_TEMPLATE_PER_ACCESS_FUNCTION,
  NETWORK_ID_ROUTE,
  TLS_PROFILE,
  PROCESS_OPTIONS_ROUTE,
  SYSTEM,
  MISCELLANEOUS,
  TARGET_TEMPLATE,
  NETWORK,
  SECURITY,
  XDP,
  TARGET_DOMAIN,
  CF_GROUP_ROUTE,
  CSP_CONFIG_ROUTE,
  NAT_CONFIGURATION_ROUTE,
  JURISDICTION_AREA,
  CF_FTP_INFO_ROUTE,
  FILTER_SETTING,
  FILTER_GROUP,
  AF_FILTER,
  FILTERS,
  SIP_SETTING,
  REGISTERED_NODES,
  BACKUP_RESTORE,
  FQDN,
  XTP,
  XTP_XDP_CONNECTION,
  RADIUS_PARSER_OPTIONS,
  RADIUS_PARSER_PASSWORD,
  SSH_SECURITY_INFORMATION,
  NETWORK_TOPOLOGY,
  MEDIA_GATEWAY,
  ALARM_NOTIFICATION_PROFILE,
  AFWHITELIST,
  XCCA,
  XCCA_DASHBOARD,
  SNMP_USERS,
  SNMP_DEST,
  CONTACT,
  EWARRANT_ROUTE,
  TENANT_ROUTE,
} from './constants';

// eslint-disable-next-line import/prefer-default-export
export const Projects = [
  {
    path: `${EWARRANT_ROUTE}*`,
    component: EWarrant,
    permissions: 'eWarrants',
  },
  {
    path: `${NETWORK_TOPOLOGY}*`,
    component: NetworkTopology,
    permissions: 'topology',
  },
  {
    path: '/logs*',
    component: LogView,
    permissions: 'logs'
  },
  {
    path: '/warrants*',
    component: WarrantsModule,
    permissions: 'warrants',
  },
  {
    path: '/users*',
    component: UsersModule,
    permissions: 'users',
  },
  {
    path: '/teams*',
    component: TeamsModule,
    permissions: 'teams',
  },
  {
    path: '/roles*',
    component: RolesModule,
    permissions: 'roles',
  },
  {
    path: '/security-policy*',
    component: SecurityPolicy,
    permissions: 'securityPolicy',
  },
  {
    path: `${TENANT_ROUTE}*`,
    component: Tenant,
    permissions: 'tenant',
  },
  {
    path: '/audit*',
    component: AuditModule,
    permissions: 'general',
  },
  {
    path: '/userAudit*',
    component: UserAuditModule,
    permissions: 'userAudit',
  },
  {
    path: '/cases*',
    component: CasesModule,
    permissions: 'cases',
  },
  {
    path: '/wiretaps*',
    component: WiretapsModule,
    permissions: 'wiretaps',
  },
  {
    path: `${AF_ROUTE}/xms`,
    component: ExternalApps,
    permissions: 'xms_af',
  },
  {
    path: `${AF_ROUTE}*`,
    component: AccessFunction,
    permissions: 'afs',
  },
  {
    path: `${CF_ROUTE}*`,
    component: CollectionFunction,
    permissions: 'cfs',
  },
  // {
  //   path: `${ALARM}*`,
  //   component: Alarm,
  //   permissions: 'alarm',
  // },
  {
    path: '/activeAlarms',
    component: ActiveAlarmList,
    permissions: 'alarm',
  },
  {
    path: '/suppressedAlarms',
    component: SuppressedAlarmList,
    permissions: 'alarm',
  },
  {
    path: '/historicalAlarms',
    component: HistoricalAlarmList,
    permissions: 'alarm',
  },
  {
    path: '/xms/reports*',
    component: ExternalApps,
    permissions: 'xms_reports',
  },
  {
    path: '/xms/alarm*',
    component: ExternalApps,
    permissions: 'xms_alarm',
  },
  {
    path: '/xms/monitoring*',
    component: ExternalApps,
    permissions: 'xms_monitoring',
  },
  {
    path: '/xms/systemhealth*',
    component: ExternalApps,
    permissions: 'xms_system_health',
  },
  {
    path: '/xms/sysconfhome*',
    component: ExternalApps,
    permissions: 'xms_system_conf',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}/xms`,
    component: ExternalApps,
    permissions: 'xms_system_conf',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${SECURITY_GATEWAY_ROUTE}*`,
    component: TlsProxy,
    permissions: 'securityGateway',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${DISTRIBUTORS_ROUTE}*`,
    component: Distributor,
    permissions: 'ss8_distributors',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${ALARM_NOTIFICATION_PROFILE}*`,
    component: AlarmNotificationProfile,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${IRI_BUFFERING_ROUTE}*`,
    component: IRIBuffering,
    permissions: 'dipms', // 'iri_buffering',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${PERIODIC_AUDIT_ROUTE}*`,
    component: PerodicAudit,
    permissions: 'dipms', // 'periodic_audit',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${CF_GROUP_ROUTE}*`,
    component: CollectionFunctionGroup,
    permissions: 'cf_groups',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${CSP_CONFIG_ROUTE}*`,
    component: CspConfig,
    permissions: 'csp_configs',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${PROCESS_OPTIONS_ROUTE}*`,
    component: ProcessOptions, // need to add process options
    permissions: 'process_options',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${DIALED_DIGIT_EXTRACTION_SERVER_ROUTE}*`,
    component: DialedDigitExtractionServer,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${UTIMACO_PACKET_SWITCH_ROUTE}*`,
    component: UtimacoPacketSwitch,
    permissions: 'utmpktcfcis',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${UTIMACO_CIRCUIT_SWITCH_ROUTE}*`,
    component: UtimacoCircuitSwitch,
    permissions: 'utmpktcfcis',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${TARGET_TEMPLATE}${TARGET_DELIVERY_TEMPLATE_PER_ACCESS_FUNCTION}*`,
    component: TargetDeliveryTemplateAccessFunction,
    permissions: 'dipms', // TODO: Confirm with XMS team
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${NETWORK_ID_ROUTE}*`,
    component: NetworkId,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${RADIUS_PARSER_OPTIONS}*`,
    component: RadiusParserOptions,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${XTP}*`,
    component: Xtp,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${XDP}*`,
    component: Xdp,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${XTP_XDP_CONNECTION}*`,
    component: XtpXdpConnection,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${RADIUS_PARSER_PASSWORD}*`,
    component: RadiusParserPassword,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${FQDN}*`,
    component: Fqdn,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${SNMP_DEST}*`,
    component: SnmpDestination,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${SECURITY}${TLS_PROFILE}*`,
    component: TlsProfile,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${SECURITY}${SSH_SECURITY_INFORMATION}*`,
    component: SshSecurityInformation,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${SECURITY}${SNMP_USERS}*`,
    component: SnmpUser,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${TARGET_DOMAIN}*`,
    component: TargetDomain,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${NAT_CONFIGURATION_ROUTE}*`,
    component: NatConfiguration,
    permissions: 'dipms',
  },
  {
    path: '/external/dashboard*',
    component: ExternalApps,
    permissions: 'external-dashboard',
  },
  {
    path: '/external/systemhealth*',
    component: ExternalApps,
    permissions: 'external-system-health',
  },
  {
    path: '/external/monitoring/agglicenses*',
    component: ExternalApps,
    permissions: 'agg-licenses',
  },
  {
    path: '/external/monitoring/xcipiolicenses*',
    component: ExternalApps,
    permissions: 'xcipio-licenses',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${JURISDICTION_AREA}*`,
    component: JurisdictionArea,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${CF_FTP_INFO_ROUTE}*`,
    component: CfFtpInfo,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${FILTER_SETTING}${FILTER_GROUP}*`,
    component: FilterGroup,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${FILTER_SETTING}${AF_FILTER}*`,
    component: AfFilter,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${FILTER_SETTING}${FILTERS}*`,
    component: Filters,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${SIP_SETTING}*`,
    component: SipSetting,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${REGISTERED_NODES}*`,
    component: RegisteredNodes,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${BACKUP_RESTORE}*`,
    component: BackupRestore,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${XCCA}${XCCA_DASHBOARD}*`,
    component: Xcca,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${MEDIA_GATEWAY}*`,
    component: MediaGateway,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${AFWHITELIST}*`,
    component: AfWhitelist,
    permissions: 'dipms',
  },
  {
    path: `${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${CONTACT}*`,
    component: Contact,
    permissions: 'cf_groups',
  },
];
